// import { createStore } from 'vuex';
import {defineStore} from "pinia";
import {ref} from 'vue'

export const useStore = defineStore('id', {
  //箭头函数返回值为一个对象
  //不简写
  // var obj = () =>{
  //   return {x:1};
  // }
  //简写
  // var obj = () =>({x:1});
  //注:在简写的情况下，返回的对象必须在（）里面，否则会报错

  state: (): any => ({
    pushArray: [],
    pushArrayId: [],
    //提前批的 下拉框
    scrollTop:0,
    //移动端 mobileFirstPage 的下拉框
    mobileFirstPageScrollTop:0,
    //移动端 mobileTransferPage 的下拉框
    mobileTransferPage:0,
  }),
  getters: {

  },
  actions: {
    deleteInfo(i:any,j:any){
     if (this.pushArray[i].majors.length ==1){
       this.pushArrayId.splice(this.pushArrayId.indexOf(this.pushArray[i].collegeId),1);
       this.pushArray.splice(i,1);

       // console.log(this.pushArray)
     }else {
       this.pushArray[i].majors.splice(j,1)
     }
    },

    clickAddInfo(item: any, item2: any): any {
      //如果id数组里什么都没有，直接push id 。直接把学校 和 点击的专业 push 到数据数组里
      if (this.pushArrayId.length == 0) {
        this.pushArrayId.push(item.collegeId);
        this.pushArray.push(item);
        this.pushArray[0].majors = [];
        this.pushArray[0].majors.push(item2);
      }
      //如果id数组里有值
      else {
        //点击的学校的id 数组里没有：那么两个数组的末尾分别push新的
        if (this.pushArrayId.indexOf(item.collegeId) == -1) {
          if (this.pushArrayId.length < 50) {
            this.pushArrayId.push(item.collegeId);
            this.pushArray.push(item);
            this.pushArray[this.pushArray.length - 1].majors = [];
            this.pushArray[this.pushArray.length - 1].majors.push(item2);
          } else {
            return '添加学校个数达到上限'
          }
        }
          //如果学校的id 数组里有，要追加的major的代码和数组里已有的major[]的代码进行 一一比对。 如果有一样的，就直接跳出整个函数
        // 如果比对到最后没有一样的，循环结束，执行循环之后的代码，也就是 在已有的major数组里 追加新的major
        else {
          for (let i = 0; i < this.pushArray[this.pushArrayId.indexOf(item.collegeId)].majors.length; i++) {
            if (this.pushArray[this.pushArrayId.indexOf(item.collegeId)].majors[i].majorCode == item2.majorCode) {
              return '重复了';
            }
          }
          this.pushArray[this.pushArrayId.indexOf(item.collegeId)].majors.push(item2);
        }
      }
      // console.log(this.pushArrayId);
      // console.log(this.pushArray);
    },

    //保存 滚动条离 顶端的值
    updateScrollTop(scrollTop:any){
      this.scrollTop =scrollTop;
    }
  }
});

